import { graphql } from '@eluve/graphql.tada';

export const getExistingCodesQuery = graphql(`
  query GetExistingMedicalCodesByType(
    $codeType: MedicalCodeTypesEnum!
    $limit: Int!
    $offset: Int!
  ) {
    medicalCodes(
      where: {
        codeType: { _eq: $codeType }
        tenantId: { _isNull: true }
        isDeprecated: { _eq: false }
      }
      orderBy: { code: ASC }
      limit: $limit
      offset: $offset
    ) {
      code
      description
    }
  }
`);

export const getLastUpdatedQuery = graphql(`
  query GetLastUpdatedByCodeType($codeType: MedicalCodeTypesEnum!) {
    medicalCodesAggregate(
      where: { codeType: { _eq: $codeType }, tenantId: { _isNull: true } }
    ) {
      aggregate {
        max {
          updatedAt
        }
        count
      }
    }
  }
`);

export const getDeprecatedCodesByTypeQuery = graphql(`
  query GetDeprecatedMedicalCodesByType(
    $codeType: MedicalCodeTypesEnum!
    $codes: [String!]!
  ) {
    medicalCodes(
      where: {
        codeType: { _eq: $codeType }
        tenantId: { _isNull: true }
        isDeprecated: { _eq: true }
        code: { _in: $codes }
      }
    ) {
      code
    }
  }
`);

export const insertMedicalCodesMutation = graphql(`
  mutation InsertGlobalMedicalCodes($objects: [MedicalCodesInsertInput!]!) {
    insertMedicalCodes(objects: $objects) {
      returning {
        id
      }
    }
  }
`);

export const deprecateMedicalCodesMutation = graphql(`
  mutation DeprecateMedicalCodes(
    $codes: [String!]!
    $codeType: MedicalCodeTypesEnum!
  ) {
    updateMedicalCodes(
      where: {
        code: { _in: $codes }
        codeType: { _eq: $codeType }
        tenantId: { _isNull: true }
      }
      _set: { isDeprecated: true }
    ) {
      affectedRows
    }
  }
`);

export const deleteMedicalCodesByIdsMutation = graphql(`
  mutation DeleteMedicalCodesByIds($ids: [uuid!]!) {
    deleteMedicalCodes(
      where: { id: { _in: $ids }, tenantId: { _isNull: true } }
    ) {
      affectedRows
    }
  }
`);

export const undoDeprecateMedicalCodesMutation = graphql(`
  mutation UndoDeprecateMedicalCodes(
    $codes: [String!]!
    $codeType: MedicalCodeTypesEnum!
  ) {
    updateMedicalCodes(
      where: {
        code: { _in: $codes }
        codeType: { _eq: $codeType }
        tenantId: { _isNull: true }
      }
      _set: { isDeprecated: false }
    ) {
      affectedRows
    }
  }
`);
